import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../queries/book-appointment.js';
import '../../queries/get-calendar-availability.js';
import { GET_TIME_SLOTS } from '../../queries/get-time-slots.js';
import '../../queries/get-store-offer-by-code.js';
import '../../queries/get-user.js';
import '../../queries/get-store-opening-times.js';
import '../../queries/get-availability-stores-nearby.js';
import { fromTimeSlotsQueryToTimeSlots } from './adapters/fromTimeSlotsQueryToTimeSlots.js';
import '@grandvisionhq/stores-v2';

const useTimeSlots = (props = {})=>{
    const timeSlotsMetadataRef = React.useRef();
    const [timeSlotsMetadata1, setTimeSlotsMetadata] = React.useState();
    const { locale  } = useIntl();
    const { timeFilters  } = props;
    const [query, queryState] = useLazyQuery(GET_TIME_SLOTS, {
        fetchPolicy: 'no-cache',
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        onCompleted: (data)=>{
            if ((data === null || data === void 0 ? void 0 : data.timeSlots) && timeSlotsMetadataRef.current) {
                // we only trigger a rerender when our query is resolved and not when requested
                setTimeSlotsMetadata(timeSlotsMetadataRef.current);
                return;
            }
            setTimeSlotsMetadata(undefined);
        }
    });
    const data1 = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.timeSlots) ? fromTimeSlotsQueryToTimeSlots(queryState.data.timeSlots) : null;
    }, [
        queryState
    ]);
    const filtered = React.useMemo(()=>{
        const result = {
            included: [],
            excluded: []
        };
        if (!data1) {
            return result;
        }
        const sorted = data1.sort((a, b)=>a.from.getTime() - b.from.getTime()
        );
        if (!(timeFilters === null || timeFilters === void 0 ? void 0 : timeFilters.length)) {
            result.included = sorted;
            return result;
        }
        return sorted.reduce((acc, timeSlot)=>{
            const include = timeFilters.some((filter)=>filter(timeSlot.from)
            );
            if (include) {
                acc.included.push(timeSlot);
            } else {
                acc.excluded.push(timeSlot);
            }
            return acc;
        }, result);
    }, [
        timeFilters,
        data1
    ]);
    const getTimeSlotsQuery = React.useCallback((options, timeSlotsMetadata)=>{
        timeSlotsMetadataRef.current = timeSlotsMetadata;
        query(options);
    }, [
        query
    ]);
    return React.useMemo(()=>[
            getTimeSlotsQuery,
            swcHelpers.objectSpread({}, queryState, {
                data: data1,
                filtered,
                metadata: timeSlotsMetadata1
            }), 
        ]
    , [
        data1,
        filtered,
        timeSlotsMetadata1,
        queryState,
        getTimeSlotsQuery
    ]);
};

export { useTimeSlots as default };
//# sourceMappingURL=use-time-slots.js.map
